<template>
  <div class="review-extra-services-sub-item-component">
    <!-- Usando flexbox para melhor controle no mobile -->
    <div class="columns is-mobile is-vcentered is-justify-content-space-between">
        <!-- Coluna do Nome (ocupa espaço disponível) -->
        <div class="column is-narrow-tablet is-narrow-desktop is-narrow-widescreen is-narrow-fullhd is-flex-grow-1 is-flex-shrink-1 is-truncate-text">
          <!-- Tamanhos de texto responsivos -->
          <span class="is-size-7-mobile is-size-6-tablet has-text-weight-bold has-text-grey-secondary is-no-wrap">
            {{ name }}
          </span>
        </div>
        <!-- Coluna do Preço (tamanho automático) -->
        <div class="column is-narrow">
          <span class="is-pulled-right">
            <!-- Tamanhos de texto responsivos -->
            <span class="is-size-7-mobile is-size-6-tablet has-text-weight-light has-text-grey-secondary">
              R$ {{ price }}
            </span>
          </span>
        </div>
      </div>
  </div>
</template>

<script>

export default {

  name: 'review-extra-services-sub-item',

  props: {
    name: {
      required: true,
      type: String
    },
    price: {
      required: true,
      type: String
    }
  },

}

</script>